export enum bookingMicrocopy {
  BOOKING_YOUR_CAR_TITLE = 'BOOKING_YOUR_CAR_TITLE',
  BOOKING_CONTINUE_CTA_LABEL = 'BOOKING_CONTINUE_CTA_LABEL',
  BOOKING_LOCATION_SELL_TO_CARMA_LABEL = 'BOOKING_LOCATION_SELL_TO_CARMA_LABEL',
  BOOKING_LOCATION_TITLE = 'BOOKING_LOCATION_TITLE',
  BOOKING_LOCATION_SUBTITLE = 'BOOKING_LOCATION_SUBTITLE',
  BOOKING_LOCATION_UPDATE_TITLE = 'BOOKING_LOCATION_UPDATE_TITLE',
  BOOKING_LOCATION_UPDATE_SUBTITLE = 'BOOKING_LOCATION_UPDATE_SUBTITLE',
  BOOKING_LOCATION_SELECT_TITLE = 'BOOKING_LOCATION_SELECT_TITLE',
  BOOKING_LOCATION_REGO_TITLE = 'BOOKING_LOCATION_REGO_TITLE',
  BOOKING_LOCATION_STATE_TITLE = 'BOOKING_LOCATION_STATE_TITLE',
  BOOKING_TIME_TITLE = 'BOOKING_TIME_TITLE',
  BOOKING_TIME_SUBTITLE = 'BOOKING_TIME_SUBTITLE',
  BOOKING_TIME_UPDATE_TITLE = 'BOOKING_TIME_UPDATE_TITLE',
  BOOKING_TIME_UPDATE_SUBTITLE = 'BOOKING_TIME_UPDATE_SUBTITLE',
  BOOKING_COMPANY_TITLE = 'BOOKING_COMPANY_TITLE',
  BOOKING_COMPANY_SUBTITLE = 'BOOKING_COMPANY_SUBTITLE',
  BOOKING_COMPANY_UPDATE_TITLE = 'BOOKING_COMPANY_UPDATE_TITLE',
  BOOKING_COMPANY_UPDATE_SUBTITLE = 'BOOKING_COMPANY_UPDATE_SUBTITLE',
  BOOKING_CONFIRM_TITLE = 'BOOKING_CONFIRM_TITLE',
  BOOKING_CONFIRM_SUBTITLE = 'BOOKING_CONFIRM_SUBTITLE',
  BOOKING_UPDATE_TITLE = 'BOOKING_UPDATE_TITLE',
  BOOKING_UPDATE_SUBTITLE = 'BOOKING_UPDATE_SUBTITLE',
  BOOKING_END_TITLE = 'BOOKING_END_TITLE',
  BOOKING_END_SUBTITLE = 'BOOKING_END_SUBTITLE',
  BOOKING_END_UPDATE_TITLE = 'BOOKING_END_UPDATE_TITLE',
  BOOKING_END_UPDATE_SUBTITLE = 'BOOKING_END_UPDATE_SUBTITLE',
  BOOKING_END_MANAGE_TITLE = 'BOOKING_END_MANAGE_TITLE',
  BOOKING_END_MANAGE_SUBTITLE = 'BOOKING_END_MANAGE_SUBTITLE',
  BOOKING_CANCELLED_TITLE = 'BOOKING_CANCELLED_TITLE',
  BOOKING_CANCELLED_SUBTITLE = 'BOOKING_CANCELLED_SUBTITLE',
}
